export default {
  主页面标题: "尋源需求管理",
  申请寻源按钮: "申請尋源",
  导入寻源计划按钮: "導入尋源計劃",
  导入寻源计划: "導入尋源計劃",
  导入关闭: "關閉",
  导入确认: "確認",
  寻源类型: "尋源類型",
  点击下载: "點擊下載",
  下载模版: "下載模版",
  寻源计划文件: "尋源計劃文件",
  请上传寻源计划文件: "請上傳尋源計劃文件",
  点击上传: "點擊上傳",
  寻源信息: "尋源信息",
  工厂: "工廠",
  请选择工厂: "請選擇工廠",
  寻源类别: "尋源類別",
  请选择寻源类别: "請選擇尋源類別",
  寻源二级类别: "尋源二級類別",
  请选择二级寻源类别: "請選擇二級尋源類別",
  成本中心: "成本中心",
  请选择成本中心: "請選擇成本中心",
  序号: "序號",
  物料编号: "物料編號",
  物料名称: "物料名稱",
  年采购数量: "年採購數量",
  请输入编号: "請輸入編號",
  请输入物料名称: "請輸入物料名稱",
  请输入年采购数量: "請輸入年採購數量",
  相关产品: "相關產品",
  请输入相关产品: "請輸入相關產品",
  请输入要求完成日期: "請輸入要求完成日期",
  寻源原因: "尋源原因",
  请输入寻源原因: "請輸入尋源原因",
  寻源要求: "尋源要求",
  请输入寻源要求: "請輸入尋源要求",
  寻源优先级: "尋源優先級",
  紧急: "緊急",
  一般: "一般",
  取消寻源: "取消尋源",
  取消原因: "取消原因",
  寻源来源: "尋源來源",
  寻源方法: "尋源方法",
  计划开始时间: "計劃開始時間",
  计划结束时间: "計劃結束時間",
  寻源执行: "尋源執行",
  查看寻源进度: "查看尋源進度",
  寻源名称: "尋源名稱",
  需求数量: "需求數量",
  单价HKD: "單價HKD",
  总金额HKD: "總金額HKD",
  相关附件: "相關附件",
  现有标准物料文件: "現有標準物料文件",
  现有供应商COA: "現有供應商COA",
  URS文件: "URS文件",
  其他: "其他",
  取消寻源原因: "取消尋源原因",
  取消成功: "取消成功",
  请输入取消寻源的原因: "請輸入取消尋源的原因",
  表单底部暂存: "暫存",
  表单底部提交: "提交",
  提交成功: "提交成功",
  寻源物料产品正在处方变更: "尋源物料產品正在處方變更",
  物料质量标准确认: "物料質量標準確認",
  供应商开发和筛选: "供應商開發和篩選",
  供应商选择和评估: "供應商選擇和評估",
  供应商合格认证: "供應商合格認證（原供應商准入）",
  提供URS: "提供URS",
  用户与供应商技术沟通: "用戶與供應商技術溝通",
  采购与供应商商务沟通: "採購與供應商商務溝通",
  汇总技术与商务资料: "匯總技術與商務資料",
  采购委员会获批: "採購委員會獲批",
  合同签署获批: "合同簽署獲批",
  寻源需求申请: "尋源需求申請",
  寻源节点跟进: "尋源節點跟進",
  全部展开: "全部展開",
  全部折叠: "全部折疊",
  操作成功: "操作成功",
  完成节点: "完成節點",
  已完成: "已完成",
  待完成: "待完成",
  展开: "展開",
  折叠: "折疊",
  点击选择供应商: "點擊選擇供應商",
  处方变更确认: "處方變更確認",
  寻源物料之产品是否正在处方变更: "尋源物料之產品是否正在處方變更",
  请选择产品是否正在处方变更: "請選擇產品是否正在處方變更",
  预计处方变更完成时间: "預計處方變更完成時間",
  请选择预计处方变更完成时间: "請選擇預計處方變更完成時間",
  物料标准确认: "物料標準確認",
  现有物料标准是否可用于寻源: "現有物料標準是否可用於尋源",
  请选择现有物料标准是否可用于寻源: "請選擇現有物料標準是否可用於尋源",
  新标准物料文件: "新標準物料文件",
  生产性物料: "生產性物料",
  非生产性物料: "非生產性物料",
  当前节点完成后无法取消: "當前節點完成後無法取消",
  寻源节点维护流程: "尋源節點維護流程",
  寻源申请状态: "尋源申請狀態",
  寻源执行状态: "尋源執行狀態",
  未开始: "未開始",
  进行中: "進行中",
  已取消: "已取消",
  寻源数量: "尋源數量",
  二级寻源类别: "二級尋源類別",
  寻源负责人: "尋源負責人",
  负责人: "負責人",
  搜索物料编号名称占位符: "請輸入物料編號或名稱搜索",
  重新提交: "重新提交",
  单价: "單價",
  总金额: "總金額",
  请输入: "請輸入",
  请选择: "請選擇",
  表单编号: "表單編號",
  物料: "物料",
  申请人: "申請人",
  要求完成日期: "要求完成日期",
};
